export default "__VITE_ASSET__2dc842c2__"